<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>
<div class="sasha-tab" style="cursor: pointer" (click)="changeKeys()">Domain: {{env.domain}}</div>
